<a class="sg-add-to-calendar__button" href="" (click)="open = !open; false;">
    <mlp-ng-icon name="add-circle"></mlp-ng-icon>
    Add to my Calendar
</a>

<div class="sg-add-to-calendar__container" *ngIf="open">
    <a class="sg-add-to-calendar__link" target="_blank" [href]="sanitize(calendars.google)">
        <mlp-ng-icon class="sg-add-to-calendar__icon" name="custom-google"></mlp-ng-icon>
        Google Calendar <small class="sg-add-to-calendar__online">(Online)</small>
    </a>
    <a class="sg-add-to-calendar__link" target="_blank" [href]="sanitize(calendars.yahoo)">
        <mlp-ng-icon class="sg-add-to-calendar__icon" name="custom-yahoo"></mlp-ng-icon>
        Yahoo! Calendar <small class="sg-add-to-calendar__online">(Online)</small>
    </a>
    <a class="sg-add-to-calendar__link" target="_blank" [href]="sanitize(calendars.ical)">
        <mlp-ng-icon class="sg-add-to-calendar__icon" name="custom-apple"></mlp-ng-icon>
        Apple Calendar
    </a>
    <a class="sg-add-to-calendar__link" target="_blank" [href]="sanitize(calendars.ical)">
        <mlp-ng-icon class="sg-add-to-calendar__icon" name="calendar"></mlp-ng-icon>
        Outlook Calendar
    </a>
</div>
